import { createContext } from 'react'

import { IModalContextProps } from './ModalProvider.types'

const ModalContext = createContext<IModalContextProps>({} as IModalContextProps)

export default ModalContext
